export default __webpack_public_path__ + "static/media/king1.b6bbfcbf.png";